import { useState, useEffect } from "react";

/**
 * Returns a debounced copy of `value` that only updates after `ms`
 * milliseconds of inactivity. Useful for delaying API calls while
 * the user is still typing.
 */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);

  return debounced;
}
